module.exports = __webpack_public_path__ + "static/media/image7.6e904f0d.webp";